var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "del",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            height: 274,
            "append-to-body": "",
            confirmButtonText: this.delete,
          },
          on: {
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c("v-form-item", { attrs: { label: "产品型号" } }, [
                _vm._v(" " + _vm._s(_vm.model) + " "),
              ]),
              _c("v-form-item", { attrs: { label: "软件版本" } }, [
                _vm._v(" " + _vm._s(_vm.software_version) + " "),
              ]),
              _c(
                "v-form-item",
                { attrs: { label: "删除类型" } },
                [
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: {
                      name: "deleteType",
                      options: _vm.deleteTypeOptions,
                    },
                    model: {
                      value: _vm.del_type,
                      callback: function ($$v) {
                        _vm.del_type = $$v
                      },
                      expression: "del_type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }